
<div style="display: block; min-height: 130px;">
  <nz-upload
          [ngClass]="{ 'upload-block': true }"
          nzAction="https://jsonplaceholder.typicode.com/posts"
          nzListType="picture-card"
          [(nzFileList)]="imgHeaderList"
          [nzShowButton]="imgHeaderList.length < 1"
          [nzBeforeUpload]="preUploadImgChecks"
          [nzPreview]="headerImgPreview"
          [nzRemove] = "deleteUploadedImage"
          (nzChange)="headerImgUpdated($event)"
  >
    <i nz-icon nzType="plus"></i>
    <div class="ant-upload-text">Upload</div>
  </nz-upload>
  <!-- Uploader: Preview Modal -->
  <nz-modal [nzVisible]="headerImgPreviewVisible" [nzContent]="modalContentHeaderImg" [nzTitle]="'Image [Preview]'"
            [nzFooter]="null" (nzOnCancel)="headerImgPreviewVisible=false" nzWrapClassName="vertical-center-modal">
    <ng-template #modalContentHeaderImg>
      <img [src]="headerPreviewImage" [ngStyle]="{ 'width': '100%' }" />
    </ng-template>
  </nz-modal>
</div>
  
  
  <div *ngIf="ocrCustomResults" style="font-size: 24px; padding: 0 0 20px 0;">
    
    <h3>
    Document status: 
    <span *ngIf="ocrCustomResults.isValid" style="color: #5AA454; font-weight: 800">VALID</span>
    <span *ngIf="!ocrCustomResults.isValid" style="color: #d12112; font-weight: 800">INVALID</span>
    </h3>
    
    <h3>
      Best Guess: 
      <span>{{ocrCustomResults.documentBestGuess}}</span>
    </h3>
    
    <h3>
      Document ID:
      <span style="color: #5AA454; font-weight: 800">{{ocrCustomResults.documentId}}</span>
    </h3>
    
    <h3>
      Issued Country:
      <span class="">{{ocrCustomResults.documentCountry}}</span>
    </h3>
    
  </div>

  <nz-collapse>
    <nz-collapse-panel [nzHeader]="'OCR Data'" [nzActive]="false" [nzDisabled]="false">
      <pre>{{ ocrCustomResults | json }}</pre>
      <!--{{ocrResults | json }}-->
    </nz-collapse-panel>
  </nz-collapse>
  
  

  